<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}" style="height:320px;overflow: auto;">
    <template>
      <el-backtop target=".wrapper"></el-backtop>
    </template>
    <side-bar class="menus" v-if="!menus.loading">
      <user-menu></user-menu>
      <template slot-scope="props" slot="links">
        <template v-for="menu in menus.menus.desktop">
          <sidebar-item
            :link=getMenuLink(menu)>
            <template v-for="menuitem in menu.items">
              <sidebar-item
                :link="{name: menuitem.descripcion, path: menuitem.path, mini: menuitem.mini}">
              </sidebar-item>
            </template>
          </sidebar-item>
        </template>
      </template>

    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import UserMenu from './Extra/UserMenu.vue'
import {mapState} from "vuex";
import {Backtop} from "element-ui";

export default {
  components: {
    [Backtop.name]: Backtop,
    TopNavbar,
    ContentFooter,
    DashboardContent,
    UserMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    getMenuLink(menu) {
      if (menu.items.length === 0)
        return {name: menu.descripcion, icon: menu.icono, path: menu.path}
      return {name: menu.descripcion, icon: menu.icono}
    }
  },
  computed: {
    ...mapState({
      menus: state => state.menus
    }),
  }
}

</script>
